<template>
  <div class="indicadores-tabs">
    <div v-if="loading" class="loading-indicadores">
      <b-spinner small></b-spinner>
      <span>Carregando indicadores...</span>
    </div>

    <template v-else>
      <div class="indicadores-filtros">
        <div class="periodo-field">
          <label for="periodo-indicadores">Período</label>

          <vue-select
            id="periodo-indicadores"
            v-model="periodoSelecionado"
            :options="periodos"
            :clearable="false"
            :searchable="false"
            :disabled="loading"
            label="label"
            placeholder="Selecione o período"
            @input="alterarPeriodo"
          />
        </div>

        <div class="previsto-realizado-field">
          <FiltroPrevistoRealizado
            v-model="tipoPrevistoRealizado"
            @input="alterarTipoResultado"
          />
        </div>
      </div>

      <div class="tipos-filtro-wrap">
        <div class="tipos-filtro">
          <button
            v-for="tipo in tiposIndicadores"
            :key="tipo.key"
            type="button"
            class="tipo-filtro-btn"
            :class="{ active: tiposSelecionados.includes(tipo.key) }"
            @click="alternarTipo(tipo.key)"
          >
            {{ tipo.label }}
          </button>
          <button
            type="button"
            class="tipo-filtro-btn"
            :class="{ active: filtrarAbaixoDeCem }"
            :disabled="!todosTiposSelecionados"
            @click="alternarFiltroAbaixoDeCem"
          >
            &lt; 100%
          </button>
        </div>

        <div class="tabs-legend">
          <span
            v-for="cls in classificacoes"
            :key="cls.key"
            class="legend-item"
          >
            <span
              class="legend-dot"
              :style="{ backgroundColor: cls.color }"
            ></span>

            <span class="legend-label">
              {{ cls.label }}
            </span>
          </span>
        </div>
      </div>

      <div class="indicadores-grid">
        <div
          v-for="item in indicadoresFiltrados"
          :key="item.id"
          class="indicador-card"
          :style="{ borderColor: corPredominante(item) }"
        >
          <div class="indicador-title">
            {{ item.nome }}
          </div>

          <div class="chart-wrap">
            <DonutClassificacao
              :item="item"
              @select="abrirModalEquipesClassificacao"
            />
          </div>

          <div class="otimas-wrap">
            <div class="otimas-top">
              <span>Equipes Ótimas</span>
              <strong>{{ Number(item.percentualOtimas) }}%</strong>
            </div>

            <div class="otimas-bar">
              <div
                class="otimas-fill"
                :style="{ width: item.percentualOtimas + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!indicadoresFiltrados.length" class="empty-state">
        Nenhum indicador encontrado.
      </div>

      <b-modal
        size="xl"
        hide-footer
        centered
        v-model="modalEquipes.visible"
        body-class="p-0"
      >
        <template #modal-title>
          {{ modalEquipes.titulo }}
          <span v-if="periodoSelecionado != null" class="tag-periodo">
            {{ periodoSelecionado.label }}
          </span>
        </template>

        <div class="p-3">
          <IndicadoresDataTable
            :items="modalEquipes.items"
            :loading="modalEquipes.loading"
            :indicador="modalEquipes.indicador"
            :tipo-previsto-realizado="tipoPrevistoRealizado"
          />
        </div>
      </b-modal>
    </template>
  </div>
</template>

<script>
import IndicadoresDataTable from './IndicadoresDataTable.vue'
import DonutClassificacao from './DonutClassificacao.vue'
import FiltroPrevistoRealizado from '@/pages/IndicadoresAps/ResultadoMunicipal/components/FiltroPrevistoRealizado.vue'

export default {
  name: 'Indicadores',
  components: {
    IndicadoresDataTable,
    DonutClassificacao,
    FiltroPrevistoRealizado,
  },
  props: {},
  data() {
    return {
      loading: false,
      periodoSelecionado: null,
      periodos: [],
      dadosIndicadoresPrevistosRaw: [],
      dadosIndicadoresRealizadosRaw: [],
      dadosIndicadoresRaw: [],
      dadosIndicadores: [],
      tiposIndicadores: [
        { key: 'CVAT', label: 'CVAT' },
        { key: 'eSF', label: 'eSF' },
        { key: 'eAP', label: 'eAP' },
        { key: 'eSB', label: 'eSB' },
        { key: 'eMulti', label: 'eMulti' },
      ],
      tiposSelecionados: ['CVAT', 'eSF', 'eAP', 'eSB', 'eMulti'],
      indicadoresPorAba: {
        CVAT: [54, 55],
        eSF: [46, 51, 52, 48, 50, 49, 47],
        eAP: [46, 51, 52, 48, 50, 49, 47],
        eSB: [38, 43, 39, 42, 40, 41],
        eMulti: [44, 45],
      },
      indicadores: {
        54: 'X - Dimensão cadastro',
        55: 'Y - Dimensão acompanhamento',

        46: 'C1 - Mais acesso à APS',
        47: 'C7 - Prevenção do câncer na mulher',
        48: 'C4 - Pessoa com diabetes',
        49: 'C6 - Pessoa idosa',
        50: 'C5 - Pessoa com hipertensão',
        51: 'C2 - Desenvolvimento infantil',
        52: 'C3 - Gestante e puérpera',

        38: 'B1 - Primeira consulta programada',
        39: 'B3 - Taxa de exodontias',
        40: 'B5 - Procedimentos preventivos',
        41: 'B6 - Tratamento Restaurador Atraumático',
        42: 'B4 - Escovação Supervisionada',
        43: 'B2 - Tratamento concluído',

        44: 'M1 - Média de atendimentos por pessoa',
        45: 'M2 - Ações interprofissionais',
      },
      classificacoes: [
        { key: 'otima', label: 'Ótimo', color: '#1212b6' },
        { key: 'boa', label: 'Bom', color: '#38ba38' },
        { key: 'suficiente', label: 'Suficiente', color: '#d5ba0a' },
        { key: 'regular', label: 'Regular', color: '#c46500' },
      ],
      modalEquipes: {
        visible: false,
        loading: false,
        titulo: '',
        items: [],
        indicador: null,
      },
      tipoPrevistoRealizado: 'previsto',
      filtrarAbaixoDeCem: false,
    }
  },
  mounted() {
    this.carregarIndicadores()
  },
  computed: {
    /**
     * Retorna os tipos de indicadores atualmente selecionados.
     *
     * @return {Array}
     */
    tiposVisiveis() {
      return this.tiposIndicadores.filter((tipo) =>
        this.tiposSelecionados.includes(tipo.key)
      )
    },

    /**
     * Indica se todos os tipos de indicadores estão selecionados.
     *
     * @return {Boolean}
     */
    todosTiposSelecionados() {
      return this.tiposSelecionados.length === this.tiposIndicadores.length
    },

    /**
     * Retorna os indicadores conforme os tipos selecionados e o filtro
     * de percentual de equipes ótimas.
     *
     * @return {Array}
     */
    indicadoresFiltrados() {
      const indicadores = this.tiposVisiveis.flatMap((tipo) =>
        this.indicadoresPorTipo(tipo.key)
      )

      const indicadoresUnicos = Array.from(
        new Map(indicadores.map((item) => [item.id, item])).values()
      )

      if (!this.filtrarAbaixoDeCem) {
        return indicadoresUnicos
      }

      return indicadoresUnicos.filter(
        (item) => Number(item.percentualOtimas) < 100
      )
    },
  },
  methods: {
    /**
     * Alterna o filtro de indicadores com percentual de equipes ótimas
     * inferior a 100%.
     *
     * O filtro só pode ser utilizado quando todos os tipos estiverem
     * selecionados.
     *
     * @return {void}
     */
    alternarFiltroAbaixoDeCem() {
      if (!this.todosTiposSelecionados) {
        return
      }

      this.filtrarAbaixoDeCem = !this.filtrarAbaixoDeCem
    },

    /**
     * Altera a origem dos dados entre previsto e realizado.
     *
     * A alteração utiliza os dados previamente carregados.
     *
     * @param {String} tipo Tipo selecionado.
     * @return {void}
     */
    alterarTipoResultado(tipo) {
      this.tipoPrevistoRealizado =
        tipo === 'realizado' ? 'realizado' : 'previsto'

      this.modalEquipes.visible = false
      this.modalEquipes.items = []
      this.modalEquipes.indicador = null

      this.aplicarTipoResultado()
    },

    /**
     * Alterna a seleção de um tipo de indicador.
     *
     * Mantém sempre ao menos um tipo selecionado e desativa o filtro
     * abaixo de 100 quando nem todos os tipos estiverem selecionados.
     *
     * @param {String} tipo Chave do tipo de indicador.
     * @return {void}
     */
    alternarTipo(tipo) {
      const index = this.tiposSelecionados.indexOf(tipo)

      if (index === -1) {
        this.tiposSelecionados.push(tipo)
        return
      }

      if (this.tiposSelecionados.length === 1) {
        return
      }

      this.tiposSelecionados.splice(index, 1)
      this.filtrarAbaixoDeCem = false
    },

    /**
     * Monta as opções de período a partir dos dados ativos.
     *
     * Mantém o período anteriormente selecionado quando ele também existir
     * na nova fonte de dados. Caso contrário, seleciona o mais recente.
     *
     * @return {void}
     */
    prepararPeriodos() {
      const periodoAnterior = this.periodoSelecionado?.value
      const periodosUnicos = new Map()

      this.dadosIndicadoresRaw.forEach((item) => {
        const mesAno = String(item.mes_ano || '').trim()
        const mesAnoQuad = String(item.mes_ano_quad || mesAno).trim()

        if (!mesAno) {
          return
        }

        const partes = mesAno.split('/')

        if (partes.length !== 2) {
          return
        }

        const mes = Number(partes[0])
        const ano = Number(partes[1])

        if (
          !Number.isInteger(mes) ||
          !Number.isInteger(ano) ||
          mes < 1 ||
          mes > 12
        ) {
          return
        }

        if (!periodosUnicos.has(mesAno)) {
          periodosUnicos.set(mesAno, {
            label: mesAnoQuad,
            value: mesAno,
            mes,
            ano,
          })
        }
      })

      this.periodos = Array.from(periodosUnicos.values()).sort((a, b) => {
        if (a.ano !== b.ano) {
          return b.ano - a.ano
        }

        return b.mes - a.mes
      })

      const periodoExistente = this.periodos.find(
        (periodo) => periodo.value === periodoAnterior
      )

      this.periodoSelecionado = periodoExistente || this.periodos[0] || null
    },

    /**
     * Atualiza os indicadores exibidos conforme o período selecionado.
     *
     * A alteração é feita apenas no front, sem uma nova requisição à API.
     *
     * @param {Object|null} periodo Período selecionado.
     * @return {void}
     */
    alterarPeriodo(periodo) {
      if (!periodo?.value) {
        this.dadosIndicadores = []
        return
      }

      this.filtrarIndicadoresPorPeriodo()
    },

    /**
     * Filtra os registros retornados pela API pelo período selecionado.
     *
     * @return {void}
     */
    filtrarIndicadoresPorPeriodo() {
      const mesAno = this.periodoSelecionado?.value

      if (!mesAno) {
        this.dadosIndicadores = []
        return
      }

      this.dadosIndicadores = this.dadosIndicadoresRaw.filter(
        (item) => String(item.mes_ano || '').trim() === mesAno
      )
    },

    /**
     * Define os dados ativos conforme o tipo previsto ou realizado.
     *
     * Também reconstrói os períodos usando somente os registros da fonte
     * atualmente selecionada.
     *
     * @return {void}
     */
    aplicarTipoResultado() {
      this.dadosIndicadoresRaw =
        this.tipoPrevistoRealizado === 'realizado'
          ? this.dadosIndicadoresRealizadosRaw
          : this.dadosIndicadoresPrevistosRaw

      this.prepararPeriodos()
      this.filtrarIndicadoresPorPeriodo()
    },

    /**
     * Carrega inicialmente todos os dados previstos e realizados.
     *
     * As alterações posteriores de período e tipo de resultado são realizadas
     * apenas no front, sem novas requisições.
     *
     * @return {Promise<void>}
     */
    async carregarIndicadores() {
      try {
        this.loading = true
        this.periodoSelecionado = null
        this.periodos = []
        this.dadosIndicadoresRaw = []
        this.dadosIndicadores = []
        this.dadosIndicadoresPrevistosRaw = []
        this.dadosIndicadoresRealizadosRaw = []

        const baseUrl =
          `/app/indicadores-aps/resultado-indicadores/` +
          `${this.$store.state.cod_ibge}`

        const [responsePrevisto, responseRealizado] = await Promise.all([
          this.$api.get(`${baseUrl}/distribuicao-equipes`),
          this.$api.get(`${baseUrl}/realizado`),
        ])

        this.dadosIndicadoresPrevistosRaw = Array.isArray(
          responsePrevisto?.data
        )
          ? responsePrevisto.data
          : []

        this.dadosIndicadoresRealizadosRaw = Array.isArray(
          responseRealizado?.data
        )
          ? responseRealizado.data
          : []

        this.aplicarTipoResultado()
      } catch (error) {
        console.error('Erro ao carregar os indicadores:', error)

        this.dadosIndicadoresPrevistosRaw = []
        this.dadosIndicadoresRealizadosRaw = []
        this.dadosIndicadoresRaw = []
        this.dadosIndicadores = []
        this.periodos = []
        this.periodoSelecionado = null
      } finally {
        this.loading = false
      }
    },

    /**
     * Normaliza o campo dados retornado pela API.
     *
     * O PostgreSQL pode retornar o JSON como objeto ou como string,
     * dependendo da configuração utilizada pelo PDO.
     *
     * @param {Object|String|null} dados Dados agrupados por classificação.
     * @return {Object}
     */
    normalizarDadosEquipes(dados) {
      const vazio = {
        otimo: [],
        bom: [],
        suficiente: [],
        regular: [],
      }

      if (!dados) {
        return vazio
      }

      try {
        const dadosNormalizados =
          typeof dados === 'string' ? JSON.parse(dados) : dados

        return {
          otimo: Array.isArray(dadosNormalizados.otimo)
            ? dadosNormalizados.otimo
            : [],
          bom: Array.isArray(dadosNormalizados.bom)
            ? dadosNormalizados.bom
            : [],
          suficiente: Array.isArray(dadosNormalizados.suficiente)
            ? dadosNormalizados.suficiente
            : [],
          regular: Array.isArray(dadosNormalizados.regular)
            ? dadosNormalizados.regular
            : [],
        }
      } catch (error) {
        console.warn('Falha ao normalizar os dados das equipes:', error)
        return vazio
      }
    },

    /**
     * Retorna os indicadores agrupados por tipo.
     *
     * Para os indicadores compartilhados entre eSF e eAP,
     * considera os tipos de equipe atualmente selecionados.
     *
     * @param {String} tipo Tipo do indicador.
     * @return {Array}
     */
    indicadoresPorTipo(tipo) {
      const indicadores = this.indicadoresPorAba[tipo] || []

      return indicadores.map((id) => {
        const row = this.dadosIndicadores.find(
          (item) => Number(item.indicador) === Number(id)
        )

        const dados = this.normalizarDadosEquipes(row?.dados)

        const equipes = {
          otima: this.filtrarEquipesSelecionadas(dados.otimo, id),
          boa: this.filtrarEquipesSelecionadas(dados.bom, id),
          suficiente: this.filtrarEquipesSelecionadas(dados.suficiente, id),
          regular: this.filtrarEquipesSelecionadas(dados.regular, id),
        }

        const otima = equipes.otima.length
        const boa = equipes.boa.length
        const suficiente = equipes.suficiente.length
        const regular = equipes.regular.length

        const total = otima + boa + suficiente + regular

        const percentualOtimas =
          total > 0 ? Number(((otima / total) * 100).toFixed(2)) : 0

        return {
          id,
          tipo,
          nome: this.indicadores[id],
          total,
          otima,
          boa,
          suficiente,
          regular,
          percentualOtimas,
          equipes,
        }
      })
    },

    /**
     * Filtra as equipes conforme os tipos atualmente selecionados.
     *
     * Quando somente eSF estiver selecionado, considera tp_equipe 70.
     * Quando somente eAP estiver selecionado, considera tp_equipe 76.
     * Quando ambos estiverem selecionados, mantém eSF e eAP.
     *
     * Para indicadores que não pertencem a eSF/eAP, não aplica filtro.
     *
     * @param {Array} equipes Lista de equipes.
     * @param {Number} indicador Código do indicador.
     * @return {Array}
     */
    filtrarEquipesSelecionadas(equipes, indicador) {
      const indicadoresEsfEap = [46, 51, 52, 48, 50, 49, 47]

      if (!indicadoresEsfEap.includes(Number(indicador))) {
        return equipes
      }

      const esfSelecionado = this.tiposSelecionados.includes('eSF')
      const eapSelecionado = this.tiposSelecionados.includes('eAP')

      if (esfSelecionado && eapSelecionado) {
        return equipes.filter((equipe) =>
          ['70', '76'].includes(String(equipe.tp_equipe))
        )
      }

      if (esfSelecionado) {
        return equipes.filter((equipe) => String(equipe.tp_equipe) === '70')
      }

      if (eapSelecionado) {
        return equipes.filter((equipe) => String(equipe.tp_equipe) === '76')
      }

      return equipes
    },

    /**
     * Retorna o código do tipo de equipe utilizado pela API.
     *
     * @param {String} tipo Tipo do indicador.
     * @return {String|null}
     */
    getTipoEquipe(tipo) {
      const tipos = {
        eSF: '70',
        eAP: '76',
      }

      return tipos[tipo] || null
    },

    /**
     * Filtra as equipes conforme o tipo selecionado.
     *
     * Para eSF utiliza tp_equipe 70.
     * Para eAP utiliza tp_equipe 76.
     * Os demais tipos não recebem filtro.
     *
     * @param {Array} equipes Lista de equipes.
     * @param {String} tipo Tipo do indicador.
     * @return {Array}
     */
    filtrarEquipesPorTipo(equipes, tipo) {
      const tipoEquipe = this.getTipoEquipe(tipo)

      if (!tipoEquipe) {
        return equipes
      }

      return equipes.filter((equipe) => String(equipe.tp_equipe) === tipoEquipe)
    },

    /**
     * Abre o modal com as equipes da classificação selecionada.
     *
     * Quando somente eSF ou eAP estiver selecionado, filtra as equipes
     * conforme o campo tp_equipe.
     *
     * @param {Object} slice Fatia selecionada no gráfico.
     * @return {void}
     */
    abrirModalEquipesClassificacao(slice) {
      if (!slice?.key || !slice?.item?.id) {
        return
      }

      this.modalEquipes.indicador = Number(slice.item.id)
      this.modalEquipes.visible = true
      this.modalEquipes.loading = false
      this.modalEquipes.titulo = `${slice.item.nome} - ${slice.label}`
      this.modalEquipes.items = slice.item?.equipes?.[slice.key] || []
    },

    /**
     * Filtra as equipes exibidas no modal conforme o filtro de tipo.
     *
     * @param {Array} equipes Equipes da classificação selecionada.
     * @return {Array}
     */
    filtrarEquipesModal(equipes) {
      const esfSelecionado = this.tiposSelecionados.includes('eSF')
      const eapSelecionado = this.tiposSelecionados.includes('eAP')

      if (esfSelecionado && !eapSelecionado) {
        return equipes.filter((equipe) => String(equipe.tp_equipe) === '70')
      }

      if (eapSelecionado && !esfSelecionado) {
        return equipes.filter((equipe) => String(equipe.tp_equipe) === '76')
      }

      return equipes
    },

    /**
     * Monta as configurações visuais do gráfico donut.
     *
     * @param {Object} item Indicador agrupado.
     * @return {Object}
     */
    chartOptions(item) {
      return {
        labels: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
        colors: [
          '#1212b6', // Ótimo
          '#38ba38', // Bom
          '#d5ba0a', // Suficiente
          '#c46500', // Regular
        ],

        chart: {
          type: 'donut',
          sparkline: {
            enabled: true,
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 850,
          },
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.abrirModalEquipesClassificacao(config, item)
            },
          },
        },

        legend: {
          show: false,
        },

        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex]
          },
          style: {
            fontSize: '11px',
            fontWeight: 800,
            colors: ['#fff'],
          },
          dropShadow: {
            enabled: false,
          },
        },

        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
            expandOnClick: false,
            donut: {
              size: '58%',
              labels: {
                show: false,
              },
            },
          },
        },

        stroke: {
          width: this.temMaisDeUmaClassificacao(item) ? 3 : 0,
          colors: ['#ffffff'],
        },

        tooltip: {
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: function (val) {
              return `${val} equipe(s)`
            },
          },
        },
      }
    },

    /**
     * Monta a série do gráfico donut.
     *
     * @param {Object} item Indicador agrupado.
     * @return {Array}
     */
    chartSeries(item) {
      return [
        Number(item.otima || 0),
        Number(item.boa || 0),
        Number(item.suficiente || 0),
        Number(item.regular || 0),
      ]
    },

    /**
     * Verifica se o indicador possui mais de uma classificação com equipes.
     *
     * @param {Object} item Indicador.
     * @return {Boolean}
     */
    temMaisDeUmaClassificacao(item) {
      const valores = [item.otima, item.boa, item.suficiente, item.regular]

      return valores.filter((v) => Number(v) > 0).length > 1
    },

    /**
     * Retorna a cor da classificação predominante do indicador.
     *
     * Em caso de empate, a prioridade é:
     * Regular > Suficiente > Bom > Ótimo.
     *
     * @param {Object} item Indicador agrupado.
     * @return {String}
     */
    corPredominante(item) {
      const classificacoes = [
        {
          quantidade: Number(item.regular || 0),
          cor: '#c46500',
        },
        {
          quantidade: Number(item.suficiente || 0),
          cor: '#d5ba0a',
        },
        {
          quantidade: Number(item.boa || 0),
          cor: '#38ba38',
        },
        {
          quantidade: Number(item.otima || 0),
          cor: '#1212b6',
        },
      ]

      return classificacoes.sort((a, b) => b.quantidade - a.quantidade)[0].cor
    },
  },
}
</script>

<style lang="scss" scoped>
.indicadores-tabs {
  margin-top: 28px;
  animation: fadeInUp 0.8s ease;

  .tipos-filtro-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
    margin-bottom: 24px;
    padding: 14px 16px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
  }

  .tipos-filtro {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .tipo-filtro-btn {
    border: 1px solid #cbd5e1;
    background: #ffffff;
    color: #475569;
    border-radius: 999px;
    padding: 7px 14px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: #4f46e5;
      color: #4f46e5;
    }

    &.active {
      background: #4f46e5;
      border-color: #4f46e5;
      color: #ffffff;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.45;
      background: #f1f5f9;
      border-color: #cbd5e1;
      color: #94a3b8;
    }

    &:disabled:hover {
      border-color: #cbd5e1;
      color: #94a3b8;
    }
  }

  .tabs-legend {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 12px;
    height: 100%;
    flex-wrap: wrap;

    .legend-title {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      color: #64748b;
      margin-right: 6px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;

      .legend-dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .legend-label {
        font-size: 13px;
        font-weight: 600;
        color: #475569;
        text-transform: uppercase;
      }
    }
  }

  .indicadores-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 16px;

    @media (min-width: 1200px) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }

    @media (min-width: 992px) and (max-width: 1199px) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    @media (min-width: 768px) and (max-width: 991px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (min-width: 576px) and (max-width: 767px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 575px) {
      grid-template-columns: 1fr;
    }
  }

  .indicador-card {
    background: #fff;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 10px 12px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
    transition: all 0.25s ease;
    overflow: hidden;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
    }

    .indicador-title {
      min-height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 10px;
      font-weight: 900;
      line-height: 1.25;
      color: #1f2937;
      margin-bottom: 4px;
    }

    .chart-wrap {
      height: 145px;
      margin: -2px -8px 2px;
    }

    .otimas-wrap {
      margin-top: 4px;

      .otimas-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        font-size: 9px;
        font-weight: 900;
        text-transform: uppercase;
        color: #64748b;

        strong {
          font-size: 10px;
          color: #111827;
        }
      }

      .otimas-bar {
        height: 7px;
        width: 100%;
        background: #f1f5f9;
        border-radius: 999px;
        overflow: hidden;
        box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.08);

        .otimas-fill {
          height: 100%;
          border-radius: inherit;
          transition: width 0.9s ease;
          background: linear-gradient(
            90deg,
            #c46500,
            #d5ba0a,
            #38ba38,
            #1212b6
          );
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    color: #64748b;
    padding: 32px 0;
    font-weight: 700;
  }

  ::v-deep {
    .card-header {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
    }

    .nav {
      flex: 1;
      align-items: center;
      gap: 6px;
    }

    .nav-pills {
      .nav-link {
        border-radius: 999px;
        font-weight: 800;

        &.active {
          background: #4f46e5;
        }
      }
    }

    .apexcharts-tooltip {
      border-radius: 14px !important;
      box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18) !important;
      border: 1px solid #e2e8f0 !important;
    }

    .apexcharts-tooltip-title {
      font-size: 11px !important;
      font-weight: 900 !important;
    }

    .apexcharts-tooltip-text-y-label,
    .apexcharts-tooltip-text-y-value {
      font-size: 11px !important;
      font-weight: 800 !important;
    }
  }

  @media (max-width: 767px) {
    ::v-deep {
      .card-header {
        justify-content: center;
      }

      .nav {
        flex: 0 0 100%;
        justify-content: center;
        margin-bottom: 8px;
      }

      .nav-item.ml-auto {
        margin-left: 0 !important;
        flex: 0 0 100%;
        display: flex;
        justify-content: center;
      }
    }

    .tabs-legend {
      width: 100%;
      justify-content: center;
      padding: 8px 0;
      gap: 10px;
    }
  }

  .indicadores-filtros {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: 18px;

    .periodo-field {
      width: 240px;

      label {
        display: block;
        margin-bottom: 6px;
        color: #475569;
        font-size: 12px;
        font-weight: 800;
        letter-spacing: 0.5px;
      }
    }

    .previsto-realizado-field {
      min-height: 40px;
      display: flex;
      align-items: center;
      padding-bottom: 2px;
    }

    @media (max-width: 575px) {
      align-items: stretch;

      .periodo-field {
        width: 100%;
      }

      .previsto-realizado-field {
        width: 100%;
        min-height: auto;
        padding-bottom: 0;
      }
    }
  }

  .loading-indicadores {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #64748b;
    font-weight: 700;
  }

  ::v-deep {
    .periodo-field {
      .vs__dropdown-toggle {
        min-height: 40px;
        border: 1px solid #dbe2ea;
        border-radius: 8px;
        background: #fff;
      }

      .vs__selected {
        color: #334155;
        font-size: 13px;
        font-weight: 700;
      }

      .vs__dropdown-menu {
        font-size: 13px;
      }
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tag-periodo {
  background: #d6d2d2;
  color: #000;
  padding: 5px 10px;
  border-radius: 32px;
  font-size: 13px;
  margin-left: 5px;
  font-weight: 700;
}
</style>
